import { Navigate, useLocation } from "react-router-dom";

import { aiAssistantCreatePath } from "./aiAssistantDeepLink";

/** `/email-templates/ai/new` : l'assistant est une modale de la page de création, le type demandé suit. */
export default function AiAssistantRedirect() {
    const { search } = useLocation();

    return <Navigate to={aiAssistantCreatePath(search)} replace />;
}
